export const isExternalLink = element =>
  Boolean(element.hostname && location.hostname !== element.hostname)
